import errorManager from '@/rollbar.js';

const checkDataValutazione = (inizioTrimestre, fineTrimestre, dataValutazione) => {
  if (inizioTrimestre === '' || fineTrimestre === '') {
    return false;
  }

  const inizio = new Date(inizioTrimestre);
  const fine = new Date(fineTrimestre);
  const data = new Date(dataValutazione);

  return data >= inizio && data <= fine;
};

const updateImportoValutazione = (
  dataValutazioneId,
  tipoValutazioneId,
  importoValutazioneId,
  divImportoValutazioneId,
  inizioTrimestre,
  fineTrimestre,
) => {
  const dataValutazione = document.querySelector(dataValutazioneId);
  const tipoValutazione = document.querySelector(tipoValutazioneId);
  const importoValutazione = document.querySelector(importoValutazioneId);
  const divImportoValutazione = document.querySelector(divImportoValutazioneId);

  const dateValid = checkDataValutazione(inizioTrimestre, fineTrimestre, dataValutazione.value);

  tipoValutazione.onchange = () => {
    if (tipoValutazione.value === '1' && dateValid) {
      importoValutazione.value = '120';
      divImportoValutazione.style.display = 'block';
    } else {
      importoValutazione.value = '0';
      divImportoValutazione.style.display = 'none';
    }
  };
};

const init = (dataValutazioneId, tipoValutazioneId, importoValutazioneId, divImportoValutazioneId, inizioTrimestre, fineTrimestre) => {
  try {
    updateImportoValutazione(
      dataValutazioneId,
      tipoValutazioneId,
      importoValutazioneId,
      divImportoValutazioneId,
      inizioTrimestre,
      fineTrimestre,
    );
  } catch (e) {
    errorManager(e);
  }
};

window.RsaaImportoValutazione = {
  init: init,
};
